import { DomainPreferences } from '../../api/types';
import { Months } from '../../common/components/timeslider/types';
import { Timestamp } from '../../types';
import {
  addMonth,
  addYear,
  fiscalYearStart,
  format,
  getFiscalQuarter,
  getFiscalYear,
  getMomentDate,
  monthEnd,
  monthStart,
  now as nowDate,
} from '../../utils-date';

// TODO: review this as we won't be able to store logic in json settings
// we should have two options: relative (e.g. last 3 months) or absolute timeframes (e.g. 2023 to 2024)
export class StoryboardDateUtils {
  constructor(public readonly now: Timestamp = nowDate()) {}
  xYearsAgo = (x: number) => {
    return addYear(this.now, -x);
  };
  startOfFiscalYear = (
    domainPreferences: DomainPreferences,
    current = monthEnd(this.now)
  ) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return format(fiscalYearStart(current, finMonth));
  };
  fiscalYearStart = (
    domainPreferences: DomainPreferences,
    current = monthEnd(this.now)
  ) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return format(fiscalYearStart(current, finMonth));
  };
  fiscalYear = (domainPreferences: DomainPreferences) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return getFiscalYear(this.now, finMonth);
  };
  fiscalQuarter = (domainPreferences: DomainPreferences) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return getFiscalQuarter(this.now, finMonth);
  };
  getFromDate_LastYear = (date: number) => {
    return addYear(date, -1);
  };
  getFromDate_LastYearStart = (date: number) => {
    return format(
      getMomentDate(this.getFromDate_LastYear(date)).startOf('year').valueOf()
    );
  };
  getFromDate_EndOfMonth = (date: number) => {
    return format(monthEnd(date));
  };
  getFromDate_LastYearEndOfMonth = (date: number) => {
    return format(monthEnd(this.getFromDate_LastYear(date)));
  };
  getFromDate_TwelveMonthsAgo = (date: number) => {
    return addMonth(date, -11);
  };
  getFromDate_TwelveMonthsAgoStartOfMonth = (date: number) => {
    return format(monthStart(this.getFromDate_TwelveMonthsAgo(date)));
  };
  getFromDate_TwelveMonthsAgoEndOfMonth = (date: number) => {
    return format(monthEnd(this.getFromDate_TwelveMonthsAgo(date)));
  };
  getFromDate_TwelveMonthsAgoFromLastYear = (date: number) => {
    return this.getFromDate_TwelveMonthsAgo(addYear(date, -1));
  };
  getFromDate_TwelveMonthsAgoFromLastYearEndOfMonth = (date: number) => {
    return format(monthEnd(this.getFromDate_TwelveMonthsAgoFromLastYear(date)));
  };
  get lastMonth() {
    return addMonth(this.now, -1);
  }
  get lastYear() {
    return this.getFromDate_LastYear(this.now);
  }
  get startOfLastYear() {
    return this.getFromDate_LastYearStart(this.now);
  }
  get lastYearEndOfMonth() {
    return this.getFromDate_LastYearEndOfMonth(this.now);
  }
  get nowEndOfMonth() {
    return this.getFromDate_EndOfMonth(this.now);
  }
  get twelveMonthsAgoFromNow() {
    return this.getFromDate_TwelveMonthsAgo(this.now);
  }
  get twelveMonthsAgoFromNowStartOfMonth() {
    return this.getFromDate_TwelveMonthsAgoStartOfMonth(this.now);
  }
  get twelveMonthsAgoFromNowEndOfMonth() {
    return this.getFromDate_TwelveMonthsAgoEndOfMonth(this.now);
  }
  get twelveMonthsAgoFromLastYear() {
    return this.getFromDate_TwelveMonthsAgoFromLastYear(this.now);
  }
  get twelveMonthsAgoFromLastYearEndOfMonth() {
    return this.getFromDate_TwelveMonthsAgoFromLastYearEndOfMonth(this.now);
  }
}
